import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import HighLobePiercingImage from '../../Assets/Piercing Services/high lobe piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function HighLobePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
            <title>High Lobe Piercing Dubai, UAE </title>
            <meta
                name="description"
                content="High Lobe Piercing Dubai, UAE for a stylish placement above the traditional lobe, performed with professional care and quality jewellery."
            />             
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in High Lobe Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          High Lobe Piercing 100-125 AED 
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={HighLobePiercingImage} alt="High Lobe Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>High Lobe Piercing</h3>

          <p>
            Elevate your ear styling with our professional high lobe piercing services in the UAE, available at an affordable price range of 100–125 AED. High lobe piercing is a modern and unique variation of traditional ear lobe piercing, placed slightly higher on the ear lobe to create a distinctive and stylish look. It is perfect for those who want to stand out while still keeping a subtle and elegant aesthetic. Whether you are enhancing your existing piercings or starting a curated ear design, our expert specialists ensure precise placement that complements your ear shape and personal style.
          </p>

          <p>
            We are committed to delivering safe and hygienic piercing services using sterile, single-use equipment and advanced techniques. Our certified professionals follow strict hygiene protocols to ensure a clean and infection-free experience for every client. Each high lobe piercing is performed with care, accuracy, and attention to detail, minimizing discomfort and ensuring a smooth procedure. Our goal is to provide a quick, gentle, and stress-free experience that leaves you confident and satisfied with your new look.
          </p>

          <p>
            High lobe piercing is an excellent choice for individuals who want to experiment with layered or stacked ear jewelry. It pairs beautifully with standard lobe and upper lobe piercings, allowing you to create a trendy and customized ear styling. Suitable for both teens and adults, this piercing option offers versatility and creativity, whether you prefer minimal studs or bold statement pieces. The procedure is simple and typically completed within minutes, making it convenient for those with busy schedules.
          </p>

          <p>
            Our specialists use techniques designed to reduce pain and promote faster healing, ensuring that your experience is as comfortable as possible. We also provide high-quality, hypoallergenic starter earrings that are safe for sensitive skin, helping to prevent irritation and allergic reactions. Our team offers personalized consultation to guide you in selecting the ideal placement for your high lobe piercing, ensuring it aligns perfectly with your desired look and existing piercings.
          </p>

          <p>
            We take pride in offering a clean, welcoming, and professional environment where clients feel relaxed and cared for. Our friendly staff is always available to answer your questions and provide reassurance, especially if you are new to piercings. From consultation to completion, we ensure every step is handled with professionalism and attention to detail.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your piercing, and we provide clear and detailed instructions to help you care for your new high lobe piercing properly. Our team will guide you on cleaning methods, recommended products, and precautions to avoid infection or irritation during the healing period. With proper care, your high lobe piercing will heal efficiently and remain a stylish addition to your overall look.
          </p>

          <p>
            Our high lobe piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and easy, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted high lobe piercing services in the UAE for a safe, stylish, and professional experience. With skilled specialists, hygienic procedures, and a focus on customer satisfaction, we help you achieve a unique and fashionable look effortlessly. Book your high lobe piercing appointment today and redefine your style with confidence.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book High Lobe Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HighLobePiercing;